import { render, staticRenderFns } from "./VTableBody.vue?vue&type=template&id=2a74bea0&scoped=true&lang=pug&"
import script from "./VTableBody.vue?vue&type=script&lang=js&"
export * from "./VTableBody.vue?vue&type=script&lang=js&"
import style0 from "./VTableBody.vue?vue&type=style&index=0&id=2a74bea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a74bea0",
  null
  
)

export default component.exports